<template>
  <div class="section fp-auto-height-responsive" id="career-section">
    <div class="bg">
      <v-container>
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2">
            <div class="section-contents text-center" ref="title">
              <h6>Career</h6>
              <h1>빠르게 변화하는 환경에 리듬을 타고, <br class="br" />함께 성장할 수 있는 분의 연락을 기대합니다</h1>
              <v-btn x-large rounded depressed color="primary" @click.stop="moveService" :data-ga-category="gaEvent.category.home.name" :data-ga-label="gaEvent.category.home.label3" :data-ga-action="gaEvent.actions.buttonClick">바로가기</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { gsap } from "gsap";
import {GaTracking} from "@/mixins/index.js";
const { mapGetters } = createNamespacedHelpers("ui");

export default {
  mixins: [GaTracking],
  name: "MainCareer",
  computed: {
    ...mapGetters(["sectionNumber"])
  },
  watch: {
    sectionNumber() {
      const { title } = this.$refs;

      if (this.sectionNumber === 4) {
        gsap.to(title, 0.4, { opacity: 1, y: 0 });
      }
    }
  },
  methods:{
    moveService(e){
      this.gaTracking(e);
      this.$router.push({name: 'CareerCulture'});
    }
  }
};
</script>
